'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zfc on 2017/7/4.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HoverComponent = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HoverComponent, _Component);

  function HoverComponent() {
    (0, _classCallCheck3.default)(this, HoverComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(HoverComponent).call(this));

    _this.state = {
      hover: false
    };
    return _this;
  }

  (0, _createClass3.default)(HoverComponent, [{
    key: 'onMouseOver',
    value: function onMouseOver() {
      this.setState({
        hover: true
      });
    }
  }, {
    key: 'onMouseLeave',
    value: function onMouseLeave() {
      this.setState({
        hover: false
      });
    }
  }, {
    key: 'itemClick',
    value: function itemClick(item) {
      var onItemClick = this.props.onItemClick;

      if (onItemClick) {
        onItemClick(item);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./HoverComponent.scss');
      var data = this.props.data;
      var hover = this.state.hover;

      return _react2.default.createElement(
        'div',
        { className: styles.hoverComponent, onClick: function onClick() {
            return _this2.itemClick(data);
          },
          onMouseOver: this.onMouseOver.bind(this),
          onMouseLeave: this.onMouseLeave.bind(this) },
        _react2.default.createElement('img', { src: data.img, alt: '',
          className: styles.img_big + ' ' + styles.ding_guodu + ' ' + (hover ? styles.hoverAfter : styles.hoverBefore) }),
        _react2.default.createElement('img', { src: data.imgTitle, alt: '', className: styles.img_txt })
      );
    }
  }]);
  return HoverComponent;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.object,
  onItemClick: _react.PropTypes.func
}, _temp);
exports.default = HoverComponent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/HoverComponent/HoverComponent.js
 ** module id = 603
 ** module chunks = 0
 **/